import * as yup from "yup";
import { convertToHz } from "../../../helpers/converters/frequency";

const validationSchema = yup.object({
  smartFilterDeviceIdList: yup.array(),
  frequencyFrom: yup.string(),
  frequencyTo: yup.string().when(
    'frequencyFrom',
    (frequencyFrom, schema) => schema.test({
      test: (frequencyTo) => {
        const frequencyFromHz = convertToHz(frequencyFrom);
        const frequencyToHz = convertToHz(frequencyTo);

        return !frequencyTo || !frequencyFrom || frequencyFromHz < frequencyToHz;
      },
      message: "Wrong frequency range",
    })
  ),
  technologyConfigurationIdList: yup.array(),
  wirelessSystemIdList: yup.array(),
  latitude: yup.string(),
  longitude: yup.string(),
  radius: yup.number().min(0, 'Cannot use negative values').when(
    'latitude',
    (latitude, schema) => schema.test({
      test: (radiusInM) => {
        return (!latitude && !radiusInM) || (latitude && radiusInM > 0);
      },
      message: "Please, set the correct filter distance",
    })
  ),
});

export default validationSchema;